import { DynamicPropertyEvent } from 'types/DynamicPropertyEvent';
import { DynamicPropertyStatus } from 'types/DynamicPropertyStatus';
import { DynamicPropertyType } from 'types/DynamicPropertyType';

import Store from '../../Store';
import { type DynamicPropertyData } from '../data';
import { type IDynamicProperty } from '../IDynamicProperty';
import type DynamicGroup from './Group';

export class DynamicProperty<T> extends Store implements IDynamicProperty<T> {
  value: T | undefined;
  initialValue: T | undefined;
  name: string = '';
  type: DynamicPropertyType = DynamicPropertyType.TEXT;
  status = DynamicPropertyStatus.LOADING;
  parent: DynamicGroup | null | undefined;

  constructor(
    parent?: DynamicGroup | null,
    name?: string,
    value?: any
  ) {
    super();
    this.parent = parent;
    if (name != null) this.name = name;
    this.value = value;
    this.initialValue = value;
  }

  set = (value: T, silent = false) => {
    this.value = this.transform(value);
    if (!silent) this.dispatch(DynamicPropertyEvent.CHANGED);
  };

  get label() {
    return this.getString();
  }

  getChanged = () => {
    return this.value !== this.initialValue;
  }

  transform = (value: any) => {
    return value;
  }

  setInitialValue = (value: T) => {
    value = this.transform(value);
    this.initialValue = value;
    this.value = value;
  }

  resetChanged = () => {
    this.initialValue = this.value;
    this.dispatch(DynamicPropertyEvent.CHANGED);
  };

  setUsingCSV = (_value: string) => {};

  onSave = () => {
    this.initialValue = this.value;
  }

  revert = () => {
    this.value = this.initialValue;
    this.dispatch(DynamicPropertyEvent.CHANGED);
  };

  getString = (): string => {  
    if(typeof this.value === 'string') return this.value;
    if(typeof this.value === 'number') return this.value.toString();
    else return '';
  }

  getPreviewData = (): any => {
    return this.getString();
  }

  getCSVData = (): string | number => {
    return this.getString();
  }

  getState = () => {
    return {
      value: this.value,
      name: this.name,
      type: this.type,
    } satisfies DynamicPropertyData;
  };
}
